"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { X, Lock, ArrowRight } from "lucide-react";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function LoginModal({ isOpen, onClose }: LoginModalProps) {
  const router = useRouter();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay backdrop */}
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-xs transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Modal Content Card */}
      <div className="relative bg-white border border-slate-100 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200 p-6 sm:p-8 flex flex-col items-center text-center">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 hover:bg-slate-50 p-2 rounded-full transition"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Lock Icon Emblem */}
        <div className="w-16 h-16 bg-emerald-50 border border-emerald-100 rounded-full flex items-center justify-center mb-5 text-emerald-600">
          <Lock className="w-8 h-8" />
        </div>

        {/* Heading */}
        <h3 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
          Login Required
        </h3>

        {/* Message */}
        <p className="text-sm text-slate-600 mt-3 mb-6 font-semibold max-w-xs leading-relaxed">
          Please log in as a **Buyer** or **FPO** to access product details, view pricing, and check contact information.
        </p>

        {/* Actions Button Stack */}
        <div className="flex flex-col gap-3 w-full">
          <button
            onClick={() => {
              onClose();
              router.push("/auth/login");
            }}
            className="w-full bg-[#0f9648] hover:bg-[#0b6330] text-white font-bold py-3 px-5 rounded-full text-sm shadow-md hover:shadow-lg transition duration-200 cursor-pointer flex items-center justify-center gap-1.5"
          >
            Log In Now <ArrowRight className="w-4 h-4" />
          </button>
          
          <button
            onClick={() => {
              onClose();
              router.push("/auth/register");
            }}
            className="w-full bg-white border border-slate-250 hover:bg-slate-50 text-slate-700 font-bold py-3 px-5 rounded-full text-sm transition duration-200 cursor-pointer"
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
}
